import React, { Fragment } from "react";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { formatLocalTime, toBool } from "../../JS/utility";
import { showGuestItinerary } from "../../../action/action";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";


export const GuestItineraryDetails = (props) => {

    const { t } = props

    const handleGoBack = () => {
        props.showGuestItinerary(false);
    }

    React.useEffect(() => {
        console.log("Guest Itinerary Selected Data Details:")
        console.log(props.show_itineray_details)
    },[])

    return (
        <div className="content-overlay">
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>

            {props.show_itineray_details.status && <section className="widgets spa-listing spa-details">
                <div class="widget-header">
                    <div class="widget-header-title">{props.show_itineray_details.itineraryData.itineraryName}</div>
                </div>
                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="row">
                            <div class="col">
                                <div class="detail-body stay-body">

                                    <div class="stay-info">
                                        <div class="stay-arrival">
                                            <div class="heading">Date</div>
                                            <div class="body">
                                                <p>{dateFormatHandler(new Date(props.show_itineray_details.itineraryData.itineraryDateTime.split(" ")[0]).toISOString(), props.dateFormat)}</p>
                                            </div>
                                        </div>
                                        <div class="stay-departure">
                                            <div class="heading">Time</div>
                                            <div class="body">
                                                <p>{formatLocalTime(new Date((props.show_itineray_details.itineraryData.itineraryDateTime)), toBool(props.timeFormat))}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="stay-info-details">
                                        <div class="stay-info-body">
                                            <p>{props.show_itineray_details.itineraryData.itineraryDescription}</p>
                                        </div>
                                    </div>

                                    <form>
                                        <div class="form-row spa-summary">
                                            <p class="heading">Details</p>

                                            {
                                                Object.keys(props.show_itineray_details.itineraryData.itineraryMetaData).map((key, index) => {
                                                    return (
                                                        <label key={index}>{key} <span>{props.show_itineray_details.itineraryData.itineraryMetaData[key]}</span></label>
                                                    );
                                                })
                                            }
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-controls">
                                <button onClick={() => handleGoBack()} class="primary">{t('guest_itinerary.back')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>}
        </div>
    )
}


const mapStateToProps = state => {
    return {
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        show_itineray_details: state.store2.show_itineray_details,
        timeFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM : true,
        guest_itinerary: state.store2.guest_itinerary,
    }
}
export default connect(mapStateToProps, { showGuestItinerary })(withTranslation('translations')(GuestItineraryDetails));